import { render } from "./LiveWideTiles.vue?vue&type=template&id=39dba07a&scoped=true"
import script from "./LiveWideTiles.vue?vue&type=script&lang=js"
export * from "./LiveWideTiles.vue?vue&type=script&lang=js"

import "./LiveWideTiles.vue?vue&type=style&index=0&id=39dba07a&scoped=true&lang=css"

import exportComponent from "D:\\dev\\mdm-crtwww-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39dba07a"]])

export default __exports__